var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28996 9.41016H2.56996C2.095 9.41016 1.70996 9.79519 1.70996 10.2702L1.70996 20.5902C1.70996 21.0651 2.095 21.4502 2.56996 21.4502H5.14996L5.14996 10.2702C5.14996 9.79519 4.76493 9.41016 4.28996 9.41016Z",
    fill: "#171A1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4886 8.67461C20.2429 8.59872 19.9872 8.56016 19.7301 8.56023L14.5701 8.56023L14.5701 5.98023C14.5701 2.69159 12.3435 1.73011 11.1662 1.68023C10.9324 1.67201 10.705 1.75781 10.535 1.91845C10.3655 2.08088 10.2698 2.3055 10.2701 2.54023L10.2701 6.52891L6.83008 10.6569L6.83008 21.4602L17.3479 21.4602C18.4828 21.4654 19.4864 20.7248 19.8161 19.6387L22.1974 11.8987C22.3984 11.2446 22.3313 10.5374 22.0108 9.93272C21.6904 9.32806 21.1428 8.8755 20.4886 8.67461Z",
    fill: "#171A1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiked);
export default __webpack_public_path__ + "static/media/liked.24a89a8221f30f7a2d41bb82d3b73fd8.svg";
export { ForwardRef as ReactComponent };